module.exports = __webpack_public_path__ + "img/fl.b73bf600.jpg";